module.exports = __webpack_public_path__ + "img/TPBANK.1b937ebe.svg";